
import React, { useState } from "react";

const faqs = [
  {
    icon: "fa-car",
    color: "#FF6B00",
    question: "What services does Shivai Travels provide?",
    answer:
      "Shivai Travels offers local cab services, airport transfers, outstation taxi bookings, corporate travel, car rentals, Tempo Traveller rentals, and chauffeur-driven vehicle services."
  },
  {
    icon: "fa-plane",
    color: "#0D6EFD",
    question: "Do you provide airport pickup and drop services?",
    answer:
      "Yes, we provide 24/7 airport pickup and drop services for Pune, Mumbai, and Navi Mumbai airports."
  },
  {
    icon: "fa-route",
    color: "#28A745",
    question: "Can I book a cab for outstation travel?",
    answer:
      "Yes, we offer outstation cab services to destinations like Mumbai, Lonavala, Goa, Nashik, Mahabaleshwar, Shirdi, and more."
  },
  {
    icon: "fa-users",
    color: "#DC3545",
    question: "Do you provide Tempo Traveller and Mini Bus rentals?",
    answer:
      "Yes, we offer Tempo Traveller and Mini Bus rentals for family tours, group outings, weddings, and corporate events."
  },
  {
    icon: "fa-clock",
    color: "#20C997",
    question: "Is your cab service available 24/7?",
    answer:
      "Yes, our customer support and cab booking services are available 24 hours a day, 7 days a week."
  },
  {
    icon: "fa-shield-alt",
    color: "#6610F2",
    question: "Why choose Shivai Travels?",
    answer:
      "We provide clean vehicles, professional drivers, transparent pricing, punctual service, and a comfortable travel experience."
  }
];

const ShivaiFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section
      style={{
        padding: "10px 0",
        background: "#f8fafc"
      }}
    >
      <div className="container">
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <span
            style={{
              color: "#FF6B00",
              fontWeight: "600",
              textTransform: "uppercase",
              letterSpacing: "1px"
            }}
          >
            Frequently Asked Questions
          </span>

          <h2
            style={{
              fontSize: "42px",
              fontWeight: "700",
              marginTop: "10px",
              color: "#1f2937"
            }}
          >
            Why Choose Shivai Travels?
          </h2>
        </div>

        <div style={{ maxWidth: "900px", margin: "0 auto" }}>
          {faqs.map((faq, index) => (
            <div
              key={index}
              style={{
                background: "#fff",
                borderRadius: "16px",
                marginBottom: "18px",
                overflow: "hidden",
                boxShadow: "0 5px 25px rgba(0,0,0,0.08)"
              }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                style={{
                  width: "100%",
                  padding: "22px 25px",
                  border: "none",
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px"
                  }}
                >
                  <div
                    style={{
                      width: "55px",
                      height: "55px",
                      borderRadius: "50%",
                      background: faq.color,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontSize: "20px"
                    }}
                  >
                    <i className={`fa ${faq.icon}`}></i>
                  </div>

                  <h4
                    style={{
                      margin: 0,
                      color: "#111827",
                      fontSize: "18px",
                      fontWeight: "600",
                      textAlign: "left"
                    }}
                  >
                    {faq.question}
                  </h4>
                </div>

                <span
                  style={{
                    fontSize: "24px",
                    color: faq.color,
                    fontWeight: "bold"
                  }}
                >
                  {activeIndex === index ? "−" : "+"}
                </span>
              </button>

              <div
                style={{
                  maxHeight: activeIndex === index ? "200px" : "0",
                  overflow: "hidden",
                  transition: "all 0.4s ease"
                }}
              >
                <div
                  style={{
                    padding: "0 25px 25px 98px",
                    color: "#6b7280",
                    lineHeight: "1.8"
                  }}
                >
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShivaiFAQ;

